import { useState } from 'react';
import Tour from 'reactour';
import { useDashboardTourLogic } from '../../../components/configs/toursteps.js';
import { useEffect } from 'react';

const DashboardTour = ({ isOpen, onRequestClose, handleTabMainChange }) => { 
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (isOpen) {
      const style = document.createElement('style');
      
      style.innerHTML = `
        .reactour__helper {
          background-color: #23A26D !important;
          color: white !important;
          font-family: Inter, sans-serif !important;
          padding: 20px !important;
          padding-top: 34px !important;
          border-radius: 8px !important;
        }
        
        .reactour__dot {
          background: rgba(255, 255, 255, 0.4) !important;
        }
        .reactour__dot--is-active {
          background: #23A26D !important;
          border: 2px solid white !important;
          color: white !important;
        }
        
        .reactour__number {
          color: white !important;
        }
        
        .reactour__close {
          color: white !important;
          filter: brightness(0) invert(1);
        }
        
        .reactour__number {
          background: #23A26D !important;
          color: white !important;
        }

        .reactour__number--is-active {
          background: #23A26D !important;
          transform: scale(1.1);
        }
        
        .reactour__controls button {
          color: white !important;
          background: rgba(255, 255, 255, 0.2) !important;
          border: 1px solid white !important;
        }
        
        .reactour__helper p {
          color: white !important;
        }

        /* Enable body scrolling */
        body.reactour__body--open {
          overflow-y: auto !important;
        }
      `;
      document.head.appendChild(style);

      // Set a small delay to ensure DOM is ready
      const timer = setTimeout(() => {
        setIsReady(true);
      }, 100);
      
      return () => {
        clearTimeout(timer);
        document.head.removeChild(style);
        setIsReady(false);
      };
    }
  }, [isOpen]);

  const { tourSteps } = useDashboardTourLogic({ handleTabMainChange });

  // Enhanced tour configuration
  const enhancedSteps = tourSteps.map(step => ({
    ...step,
    // Add scroll adjustment to ensure elements are visible
    action: (node) => {
      if (node) {
        // Scroll the element into view with smooth behavior
        node.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'center', 
          inline: 'nearest' 
        });
        
        // Optional: Add a small delay to ensure scroll completes
        setTimeout(() => {
          if (node && typeof node.focus === 'function') {
            node.focus();
          }
        }, 300);
      }
    },
    // Add position adjustment to ensure helper is visible
    position: 'bottom',
    // Optional: Add step-specific styles
    style: {
      backgroundColor: '#23A26D',
      color: 'white',
    }
  }));

  return (
    <Tour
      steps={enhancedSteps}
      isOpen={isOpen && isReady}
      onRequestClose={() => {
        onRequestClose();
        document.body.style.overflowY = 'auto';
      }}
      onAfterOpen={() => {
        // Don't disable scrolling - allow natural page scroll
        document.body.style.overflowY = 'auto';
        
        // Optional: Remove Reactour's default body class that disables scroll
        document.body.classList.remove('reactour__body--open');
      }}
      onBeforeClose={() => {
        document.body.style.overflowY = 'auto';
      }}
      accentColor="#23A26D"
      rounded={8}
      showButtons
      showCloseButton
      showNavigation
      showNumber
      maskClassName="tour-mask" 
      highlightedMaskClassName="tour-highlighted-mask"
      // Key configuration for scroll behavior
      disableKeyboardNavigation={false}
      scrollDuration={300}
      scrollOffset={100} // Adjust this value based on your header height
      // Handle step changes with proper scrolling
      onBeforeStepChange={(nextStep) => {
        // Pre-scroll to the next element
        const nextSelector = enhancedSteps[nextStep]?.selector;
        if (nextSelector) {
          const nextElement = document.querySelector(nextSelector);
          if (nextElement) {
            setTimeout(() => {
              nextElement.scrollIntoView({ 
                behavior: 'smooth', 
                block: 'center',
                inline: 'nearest'
              });
            }, 100);
          }
        }
      }}
      // Custom mask to allow scrolling
      maskSpace={10}
      // Enable interaction with the page
      disableInteraction={false}
      // Allow focus on elements
      disableFocusLock={false}
    />
  );
};

export default DashboardTour;